import { createFileRoute } from "@tanstack/react-router";
import { m } from "#/paraglide/messages";
import { useGetScansToCorrect } from "#/lib/api/scan-to-correct";
import { ScanToCorrectPage } from "#/components/pages/scan-to-correct/scan-to-correct-page";

export const Route = createFileRoute("/$tenantCode/$market/scan-to-correct")({
  beforeLoad: () => ({ getTitle: () => m["resources.scanToCorrect.name"]() }),
  component: ScanToCorrectRoute,
});

function ScanToCorrectRoute() {
  const { data, isLoading } = useGetScansToCorrect();

  return <ScanToCorrectPage data={data?.member ?? []} isLoading={isLoading} />;
}
